import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/tenant-payment-channels", {
          params: payload
        })
        .then(response => {
          commit("SET_PAYMENT_CHANNELS", response.data);
          commit("SET_PAGINATION", {
            currentPage: response.headers["x-pagination-page"],
            totalPage: response.headers["x-pagination-page-count"],
            pageTotal: response.headers["x-pagination-count"],
            totalItem: response.headers["x-pagination-total"]
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchRecord (context, type) {
    return new Promise((resolve, reject) => {
      axios.get(`/tenant-payment-channels/${type}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/tenant-payment-channels", item)
        .then((response) => {
          commit('ADD_PAYMENT_CHANNEL', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.patch("/tenant-payment-channels/" + item.type, item)
        .then((response) => {
          commit('UPDATE_PAYMENT_CHANNEL', response.data)
          resolve(response)
        })
        .catch((error) => { console.log(error); reject(error); })
    })
  },
  removeRecord ({ commit }, type) {
    return new Promise((resolve, reject) => {
      axios.delete(`/tenant-payment-channels/${type}`)
        .then((response) => {
          commit('DELETE_PAYMENT_CHANNEL', type)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  verifyGateway (context, item) {
    return new Promise((resolve, reject) => {
      axios.post("/tenant-payment-channels/gateway/verify", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
};
